// @ts-nocheck
/* eslint-disable */

import React from 'react';
import ViewEntity from '../../components/CRUD/ViewEntity';

const ViewFareMediaBatch = () => {
  return (
    <ViewEntity
      pageTitle="FareMediaBatchInfo"
      fetchApiUrl="/api/v1/web_portal/fare_media_policy_capping/fare_media_batches/:id"
      fetchApiMethod="GET"
      dataPath="data.data"
      fields={[
        {
          name: 'label',
          labelKey: 'BatchLabel',
          type: 'text',
        },
        {
          name: 'note',
          labelKey: 'Notes',
          type: 'text',
        },
        {
          name: 'fare_media_count',
          labelKey: 'FareMediaCount',
          type: 'text',
        },
        {
          name: 'organisation_name',
          labelKey: 'Organisation',
          type: 'custom',
          render: (data, additionalData, intl) => {
            const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';
            return currentLanguageCode === 'en-us'
              ? data.org_en_name
              : data.org_ar_name;
          },
        },
        {
          name: 'created_at',
          labelKey: 'CreatedAt',
          type: 'date',
        },
        {
          name: 'updated_at',
          labelKey: 'UpdatedAt',
          type: 'date',
        },
        {
          name: 'created_by_username',
          labelKey: 'CreatedBy',
          type: 'text',
        },
        {
          name: 'updated_by_username',
          labelKey: 'UpdatedBy',
          type: 'text',
        }
      ]}
      editUrl="/CardsManagement/fare-media-batches/:id/edit"
      deleteApiUrl="/api/v1/web_portal/fare_media_policy_capping/fare_media_batches/:id"
      deleteApiMethod="DELETE"
      backUrl="/CardsManagement/fare-media-batches"
      backButtonLabel="Back"
      buildTitle={(data, additionalData, intl) => {
        return data.label;
      }}
      buildDeleteConfirmMessage={(data, additionalData, currentLanguageCode, intl) => {
        return `${intl.formatMessage({ id: 'AreYouSureDeleteFareMediaBatch' })} ${data.label}?`;
      }}
      showEditButton={true}
      showDeleteButton={true}
      subsystemName="FareMediaBatches"
      permissionSystem="masterConfig"
    />
  );
};

export default ViewFareMediaBatch;
